import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import BudgetForm from 'components/forms/orders/BudgetForm';

class UserBudgetNewForm extends React.Component {
  onSubmit = args => {
    const { clientId, onSubmit } = this.props;
    onSubmit(clientId, args);
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
      onSubmitParent,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      doNotify(1, messages.budget_saved);
      if (onSubmitParent) {
        onSubmitParent(formStatus.response);
      }
    }
  };

  render() {
    const { onSubmitParent, formStatus } = this.props;

    return <BudgetForm type="new" onSubmit={this.onSubmit} onSubmitParent={onSubmitParent} formStatus={formStatus} />;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.budgetNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('budgetNew', `/api/users/${clientId}/budget.json`, args, 'post', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('budgetNew'));
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UserBudgetNewForm)
  )
);
